import React from 'react';
import './LandingPage.css';

const LandingPage = () => {
  const logoUrl = window.location.origin + "/logo.png";
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.ccuring.ccuring&hl=en";

  return (
    <div className="landing-wrapper">
        <div className="landing-container">
            
            <header className="landing-header">
                <img 
                    src={logoUrl} 
                    alt="Ccuring Logo" 
                    className="logo-img" 
                />
            </header>

            <main className="landing-main">
                <h1 className="landing-h1">
                    Smart Schedules for <br /> 
                    <span className="highlight">Safety and Lifestyle</span>
                </h1>
                
                <p className="subtitle">
                    Automate your check-ins, monitor your journeys in real-time, 
                    and ensure help is always just one trigger away.
                </p>

                <div className="btn-group">
                    {/* ✅ FIXED: Correct Play Store Link Added */}
                    <a 
                        href={playStoreUrl} 
                        target="_blank" 
                        rel="noreferrer" 
                        className="btn btn-download"
                    >
                        Download for Android
                    </a>

                    <a href="https://wa.me/2348098215018" target="_blank" rel="noreferrer" className="btn btn-whatsapp">
                        Chat on WhatsApp
                    </a>
                    <a href="mailto:Support@ccuring.com" className="btn btn-email">
                        Email Support
                    </a>
                </div>

                <div className="features">
                    <div className="feature-card">
                        <div className="feature-icon">🛡️</div>
                        <h3>Self and Shared Triggers</h3>
                        <p>Automated check-in timers for you and your circle. If you don't check in, your contacts are notified immediately.</p>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">🚨</div>
                        <h3>Emergency Alerts</h3>
                        <p>Loud, high-priority SOS alerts that bypass silent modes. Sends your live location and records evidence when seconds count.</p>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">📍</div>
                        <h3>Journey Scan</h3>
                        <p>Real-time transit updates for every stop on the route. Stay notified from departure to final safe arrival.</p>
                    </div>
                </div>
            </main>

            <footer className="landing-footer">
                &copy; {new Date().getFullYear()} Ccuring Safety. All rights reserved.
            </footer>
        </div>
    </div>
  );
};

export default LandingPage;